module.exports = __webpack_public_path__ + "static/media/primeiros-passos.1f06eeac.png";